import MediaTemplate from "components/templates/MediaTemplate/MediaTemplate";

const MediaPage = () => {
  return <MediaTemplate />;
};

export default MediaPage;
